import animation from '@helpers/animation';
import { useInView } from '@hooks/useInView';
import { LinkButton } from '@stories/Components/Buttons/GeneralButton/Button';
import MediaCard from '@stories/Components/Cards/MediaCard/MediaCard';
import React from 'react';
import S from './CtaCardWidget.styles';
import { createAnchor } from '@helpers/text';
import { imageUrl } from '@helpers/image';
const CtaCardWidget = ({ cta1, cta2, items, summary, theme, fullHeightCards = false, title, image, pageContext, componentTheme = 0 /* Default */, }) => {
    const [refInView, inView] = useInView({
        rootMargin: animation.inView.rootMargin,
    }, false, pageContext?.isEditMode);
    return (React.createElement(S.Container, { ref: refInView, padding: true, "data-theme": theme, "data-is-active": inView, "data-component-theme": componentTheme },
        React.createElement(S.Inner, null,
            title && React.createElement(S.TitleWrapper, null,
                React.createElement(S.Title, { id: createAnchor(title) }, title)),
            summary && React.createElement(S.SummaryWrapper, null,
                React.createElement(S.Summary, null, summary)),
            image && React.createElement(S.ImageWrapper, null,
                React.createElement(S.Image, { alt: image.altText ?? '', loading: "lazy", role: image.altText ? undefined : 'presentation', src: imageUrl(image, { width: 560, height: 695, crop: 'crop' }), srcSet: [
                        `${imageUrl(image, { width: 560, height: 695, crop: 'crop' })} 1x`,
                        `${imageUrl(image, { width: 840, height: 1042, crop: 'crop' })} 1.5x`,
                        `${imageUrl(image, { width: 1120, height: 1390, crop: 'crop' })} 2x`,
                    ].join(', '), width: "560", height: "695" })),
            (cta1 || cta2) && (React.createElement(S.CtaWrapper, null,
                cta1?.text && (React.createElement(LinkButton, { branding: "primary", href: cta1.url, target: cta1.target, title: cta1.text })),
                cta2?.text && (React.createElement(LinkButton, { branding: "primary", href: cta2.url, target: cta2.target, title: cta2.text }))))),
        React.createElement(S.ItemList, null, items.map((item) => (React.createElement(S.Item, { key: item.id },
            React.createElement(MediaCard, { ...item, fullHeight: fullHeightCards, componentTheme: componentTheme })))))));
};
export default CtaCardWidget;
